import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a2a6fbb&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a2a6fbb')) {
      api.createRecord('2a2a6fbb', component.options)
    } else {
      api.reload('2a2a6fbb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2a2a6fbb&", function () {
      api.rerender('2a2a6fbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers_portal/tracking/index.vue"
export default component.exports